import { z } from "zod";

const CreateRiskSchema = z
  .object({
    title: z
      .string()
      .min(1, { message: "Title is required." })
      .max(400, { message: "Title must not be longer than 400 characters." }),
    description: z.string().min(1, { message: "Description is required." }),
    typeId: z.string().uuid({ message: "Type is required." }),
  })
  .strict();

export default CreateRiskSchema;
